<template>
  <div class="pageContent">
    <div class="reportList">
      <van-notice-bar scrollable text="温馨提示：本服务提供的资料仅供快捷浏览，报告内容以纸质报告为准，如需医学判断，请咨询医生。" />
      <div v-if="loading" class="listLoading">
        <van-loading size="28px" vertical>检查结果加载中...</van-loading>
      </div>
      <template v-else>
        <div class="total">
          <span>您当前共有{{ total }}份检查结果</span>
        </div>

        <div class="dropdown" v-if="isDropdown">
          <p class="label">{{ dropdownName }}</p>
          <van-dropdown-menu active-color="#1989fa">
            <van-dropdown-item
              :title="title"
              v-model="value1"
              :options="dockList"
              @change="dropdownChange"
            />
          </van-dropdown-menu>
        </div>
        <div class="noData" v-if="isData">暂无数据~</div>
        <ReportResult
          :listData="listData"
          @getPatientInfo="getPatientInfo"
          @getWechatPay="getWechatPay"
          @callReportPrint="callReportPrint"
          @emailShowFn="emailShowFn"
        />
      </template>

      <div v-show="!outerLinkParams && !isForwardedSearchLink">
        <div class="back" v-if="isBack && institution_id != '52200003'" @click="toback">返回</div>
        <div class="back backSearch" v-else @click="toback">返回搜索</div>
      </div>
    </div>
    <div id="mask" @click.stop v-show="show"></div>
    <div class="scrollBoxModel" v-show="show">
      <div class="scrollBox">
        <agreement />
        <van-button
          round
          block
          type="info"
          native-type="submit"
          @click.native="onSure"
          style="position:fixed;width:80%;bottom:75px;"
        >同意</van-button>
      </div>
    </div>
    <van-popup
      v-model="isCheck"
      :close-on-click-overlay="false"
      style="padding:0 20px 20px;width:220px;
    border-radius: 16px;"
    >
      <p style="font-weight:600;font-size:16px ">{{checkTitle}}</p>
      <input
        type="text"
        v-model="checkcode"
        maxlength="4"
        minlength="4"
        style="height:35px"
        placeholder="请输入验证信息"
      />
      <button class="checkButton" @click="onValidation">确定</button>
    </van-popup>
    <van-dialog v-model="emailShow" show-cancel-button confirm-button-color="#409eff" :before-close="beforeClose">
      <input class="email-input" placeholder="请输入邮箱号" v-model="emailValue" label="邮箱" />
    </van-dialog>
  </div>
</template>

<script>
import ReportResult from "./components/reportResult";
import {
  getAllReport,
  getAnotherAllReport,
  getPatientInfo,
  getDockList,
  dockSendEmail,
  // ready2pay,
  // getLocalReport
  ready2OutFilmPay
} from "@/api/reportOuter";
import { ready2pay, getLocalReport } from "@/api/report";
import Storage from "@/tools/storage";
import wx from "weixin-js-sdk";
import axios from "axios";
import { Dialog,Notify } from "vant";
import getQueryString from "@/tools/getUrlParams";
import agreement from '@/components/agreement.vue'
export default {
  name: "reportListOuter",
  components: { agreement, ReportResult, [Dialog.Component.name]: Dialog.Component },
  data() {
    return {
      listData: [],
      total: 0,
      show: false,
      isBack: false,
      institution_id: "",
      outerLinkParams: JSON.parse(Storage.get("outerLinkParams")),
      isForwardedSearchLink: false,
      dropdownParamsOb: JSON.parse(Storage.get("dropdownParams")),
      dropdownName: "",
      value1: 0,
      dockList: [],
      isDropdown: false,
      title: "",
      isData: false,
      loading: true,
      isCheck: false,
      checkcode: "",
      check: '',
      checkTitle: "请输入身份证后四位",
      emailShow: false,
      emailValue: '',
      studyId:''
    };
  },
  watch: {
    $route(to, from) {
      if (this.dropdownParamsOb) {
        Storage.del("dropdownParams");
        this.dropdownParamsOb = null;
      }
    }
  },
  methods: {
    async sendEmailFn(done){
      try{
        let res = await dockSendEmail({ study_id: this.studyId, email: this.emailValue});
        console.log(res)
        if (res) {
          this.emailValue = ''
          done()
          Notify({ type: 'success', message: '影像正在打包处理中，请稍后到指定邮箱查看', duration: 2000, })
        }
      }catch(err){
        console.log(err)
      }
      
    },
    emailShowFn(data){
      this.emailShow = data.value
      this.studyId = data.studyId
    },
    beforeClose(action,done) {
      if(action === 'confirm'){
        let reg = /^[0-9a-zA-Z_.-]+[@][0-9a-zA-Z_.-]+([.][a-zA-Z]+){1,2}$/;
        if (reg.test(this.emailValue)) {
          this.sendEmailFn(done)
        } else {
          this.emailShow = true
          console.log(this.emailShow)
          Notify({ type: 'danger', message: '请输入正确的邮箱号' })
          done(false) 
        }
      }else{
        done()
      }
    },
    async getDockList() {
      let res = await getDockList(this.outerLinkParams);
      if (res && res.length) {
        this.dockList = res.map((item, index) => {
          return {
            text: item.showlist,
            value: index,
            label: item.name,
            code: item.code
          };
        });
        if (this.dropdownParamsOb) {
          this.dropdownName = this.dropdownParamsOb.label;
          this.title = this.dropdownParamsOb.code;
          this.value1 = this.dropdownParamsOb.value1;
        } else {
          this.dropdownName = this.dockList[0].label;
          this.title = this.dockList[0].code;
        }
        let dropdownParams = {
          code: this.title,
          institution_id: this.outerLinkParams.institution_id,
          type: this.outerLinkParams.type
        };
        this.getList(dropdownParams);
      } else {
        this.isData = true;
        this.loading = false;
      }
    },
    dropdownChange(value) {
      this.dropdownName = this.dockList[value].label;
      this.title = this.dockList[value].code;
      let dropdownParams = {
        code: this.title,
        institution_id: this.outerLinkParams.institution_id,
        type: this.outerLinkParams.type
      };
      Storage.set("dropdownParams", {
        ...dropdownParams,
        label: this.dockList[value].label,
        value1: value
      });
      this.getList(dropdownParams);
    },
    onSure() {
      this.show = false;
    },
    toback() {
      window.localStorage.removeItem("IDNumber");
      window.localStorage.removeItem("name");
      window.localStorage.removeItem("hospitalNum");
      let institution_id = window.localStorage.getItem("institution_id");
      if (institution_id == "27400005") {
        this.$router.push({ path: "/checkInfoOuter/27400005" });
      } else if (institution_id == "25500004") {
        this.$router.push({ path: "/checkInfoOuter/25500004" });
      } else if (institution_id == "52200003") {
        window.localStorage.removeItem("name52200003");
        this.$router.push({ path: "/checkInfoOuter/52200003" });
      } else if (institution_id == "43800001") {
        window.localStorage.removeItem("name43800001");
        this.$router.push({ path: "/checkInfoOuter/43800001" });
      }else if (institution_id == "25500005") {
        window.localStorage.removeItem("value25500005");
        this.$router.push({ path: "/checkInfoOuter/25500005" });
      }else if (institution_id == "30000004") {
        window.localStorage.removeItem("value30000004");
        this.$router.push({ path: "/checkInfoOuter/30000004" });
      }else if (institution_id == "73000005") {
        window.localStorage.removeItem("value73000005");
        this.$router.push({ path: "/checkInfoOuter/73000005" });
      }else if (institution_id == "06700001") {
        window.localStorage.removeItem("value06700001");
        this.$router.push({ path: "/checkInfoOuter/06700001" });
      }else if (institution_id == "012") {
        window.localStorage.removeItem("value012");
        this.$router.push({ path: "/checkInfoOuter/search" });
      }else if (institution_id == "72700001") {
        window.localStorage.removeItem("value72700001");
        this.$router.push({ path: "/checkInfoOuter/72700001" });
      }else if (institution_id == "25500004") {
        window.localStorage.removeItem("value25500004");
        this.$router.push({ path: "/checkInfoOuter/25500004" });
      }else if (institution_id == "74400013") {
        window.localStorage.removeItem("value74400013");
        this.$router.push({ path: "/checkInfoOuter/74400013" });
      }else if (institution_id == "71900001") {
        window.localStorage.removeItem("value71900001");
        this.$router.push({ path: "/checkInfoOuter/71900001" });
      } else if (institution_id == "46700002") {
        window.localStorage.removeItem("name46700002");
        this.$router.push({ path: "/checkInfoOuter/46700002" });
      }else if (institution_id == "43600001") {
        window.localStorage.removeItem("value43600001");
        this.$router.push({ path: "/checkInfoOuter/43600001" });
      }else if (institution_id == "27100005") {
        window.localStorage.removeItem("name27100005");
        this.$router.push({ path: "/checkInfoOuter/27100005" });
      }else if (institution_id == "27100006") {
        window.localStorage.removeItem("name27100006");
        this.$router.push({ path: "/checkInfoOuter/27100006" });
      } else if (institution_id == "75000001") {
        window.localStorage.removeItem("value75000001");
        this.$router.push({ path: "/checkInfoOuter/75000001" });
      } else if (institution_id == "71900005") {
        window.localStorage.removeItem("value71900005");
        this.$router.push({ path: "/checkInfoOuter/71900005" });
      }else if (institution_id == "71900006") {
        window.localStorage.removeItem("value71900006");
        this.$router.push({ path: "/checkInfoOuter/71900006" });
      }else if (institution_id == "71900007") {
        window.localStorage.removeItem("value71900007");
        this.$router.push({ path: "/checkInfoOuter/71900007" });
      }else if (institution_id == "71900008") {
        window.localStorage.removeItem("value71900008");
        this.$router.push({ path: "/checkInfoOuter/71900008" });
      }else if (institution_id == "27400007") {
        window.localStorage.removeItem("name27400007");
        this.$router.push({ path: "/checkInfoOuter/27400007" });
      }else if (institution_id == "27100009") {
        window.localStorage.removeItem("name27100009");
        this.$router.push({ path: "/checkInfoOuter/27100009" });
      }
    },
    getAllReport() {
      let IDNumber = window.localStorage.getItem("IDNumber");
      let name = window.localStorage.getItem("name");
      let hospitalNum = window.localStorage.getItem("hospitalNum");
      let institution_id = window.localStorage.getItem("institution_id");

      this.institution_id = institution_id;
      let name52200003 = window.localStorage.getItem("name52200003");
      // let name43800001 = window.localStorage.getItem("name43800001");
      let name46700002 = window.localStorage.getItem("name46700002");
      // let name43600001 = window.localStorage.getItem("name43600001");
      let name27100005 = window.localStorage.getItem("name27100005");
      let name27100006 = window.localStorage.getItem("name27100006");
      let name27400007 = window.localStorage.getItem("name27400007");
      // let name25500005 = window.localStorage.getItem("name25500005");

      let value75000001 = JSON.parse(window.localStorage.getItem("value75000001"));
      let value71900005 = JSON.parse(window.localStorage.getItem("value71900005"));
      let value71900006 = JSON.parse(window.localStorage.getItem("value71900006"));
      let value71900007 = JSON.parse(window.localStorage.getItem("value71900007"));
      let value71900008 = JSON.parse(window.localStorage.getItem("value71900008"));
      let value25500005 = JSON.parse(window.localStorage.getItem("value25500005"));
      let value43800001 = JSON.parse(window.localStorage.getItem("value43800001"));
      let value30000004 = JSON.parse(window.localStorage.getItem("value30000004"));
      let value43600001 = JSON.parse(window.localStorage.getItem("value43600001"));
      let value73000005 = JSON.parse(window.localStorage.getItem("value73000005"));
      let value06700001 = JSON.parse(window.localStorage.getItem("value06700001"));
      let value012 = JSON.parse(window.localStorage.getItem("value012"));
      let value72700001 = JSON.parse(window.localStorage.getItem("value72700001"));
      let value25500004 = JSON.parse(window.localStorage.getItem("value25500004"));
      let value74400013 = JSON.parse(window.localStorage.getItem("value74400013"));
      let value71900001 = JSON.parse(window.localStorage.getItem("value71900001"));
      let value27100009 = JSON.parse(window.localStorage.getItem("value27100009"));
      let phone = window.localStorage.getItem("phone");
      if (
        institution_id == "27400005" ||
        institution_id == "25500004" ||
        institution_id == "52200003" ||
        institution_id == "75000001"
      ) {
        this.isBack = true;
      }
      let params;
      const routeParams = this.$route && this.$route.query;
      const forwardedSearchParams = !this.outerLinkParams &&
        !IDNumber && !name && !hospitalNum && !phone &&
        routeParams && !routeParams.institution_id &&
        routeParams.type && routeParams.code;
      if (forwardedSearchParams) {
        params = {
          type: routeParams.type,
          code: routeParams.code
        };
      } else if (
        phone &&
        !this.outerLinkParams &&
        !IDNumber &&
        !this.outerLinkParams &&
        !name &&
        !hospitalNum
      ) {
        let paramsTemp = {
          institution_id: institution_id,
          type: 5,
          code: phone
        };
        params = paramsTemp;
      } else {
        if (IDNumber && !this.outerLinkParams && !name && !hospitalNum) {
          let paramsTempPhone = {
            institution_id: institution_id,
            type: 4,
            code: IDNumber
          };
          params = paramsTempPhone;
        } 
        // else if (IDNumber && !this.outerLinkParams && name && !hospitalNum) {
        //   let paramsTemps = {
        //     institution_id: institution_id,
        //     type: "4,6",
        //     code: `${IDNumber},${name}`
        //   };
        //   params = paramsTemps;
        // }
         else if (
          (IDNumber || hospitalNum) &&
          !this.outerLinkParams &&
          !name
        ) {
          let paramsTempNum = {
            institution_id: institution_id,
            type: "4,3,7,1",
            code: `${IDNumber},${hospitalNum},${hospitalNum},${hospitalNum}`
          };
          params = paramsTempNum;
        } else if (
          !IDNumber &&
          !hospitalNum &&
          !this.outerLinkParams &&
          !name &&
          (name52200003 || institution_id == "52200003")
        ) {
          let paramsTempNum = {
            institution_id: institution_id,
            type: "4,8,7,3",
            code: `${name52200003},${name52200003},${name52200003},${name52200003}`
          };
          params = paramsTempNum;
        } else if (
          !IDNumber &&
          !hospitalNum &&
          !this.outerLinkParams &&
          !name && institution_id == "43800001"
        ) {
          let paramsTempNum = {
            institution_id: institution_id,
            type: "1,3,8",
            code: `${value43800001.value1},${value43800001.value1},${value43800001.value1}`,
            must: {key:"6",value: `${value43800001.name43800001}`}
          };
          params = paramsTempNum;
        } else if (
          !IDNumber &&
          !hospitalNum &&
          !this.outerLinkParams &&
          !name &&
          (name46700002 || institution_id == "46700002")
        ) {
          let paramsTempNum = {
            institution_id: institution_id,
            type: "2,1",
            code: `${name46700002},${name46700002}`
          };
          params = paramsTempNum;
        } else if (
          !IDNumber &&
          !hospitalNum &&
          !this.outerLinkParams &&
          !name && institution_id == "43600001"
        ) {
          let paramsTempNum = {
            institution_id: institution_id,
            type: "5",
            code: `${value43600001.phone43600001}`,
            must: {key:"6",value: `${value43600001.name43600001}`}
          };
          params = paramsTempNum;
        }else if (
          !IDNumber &&
          !hospitalNum &&
          !this.outerLinkParams &&
          !name &&
          (name27100005 || institution_id == "27100005")
        ) {
          let paramsTempNum = {
            institution_id: institution_id,
            type: "2,4,3",
            code: `${name27100005},${name27100005},${name27100005}`
          };
          params = paramsTempNum;
        }else if (
          !IDNumber &&
          !hospitalNum &&
          !this.outerLinkParams &&
          !name &&
          (name27100006 || institution_id == "27100006")
        ) {
          let paramsTempNum = {
            institution_id: institution_id,
            type: "2,4,5",
            code: `${name27100006},${name27100006},${name27100006}`
          };
          params = paramsTempNum;
        }else if (
          !IDNumber &&
          !hospitalNum &&
          !this.outerLinkParams &&
          !name &&
          (name27400007 || institution_id == "27400007")
        ) {
          let paramsTempNum = {
            institution_id: institution_id,
            type: "4,5,7,3",
            code: `${name27400007},${name27400007},${name27400007},${name27400007}`
          };
          params = paramsTempNum;
        }else if (
          !IDNumber &&
          !hospitalNum &&
          !this.outerLinkParams &&
          !name && institution_id == "75000001"
        ) {
          let paramsTempNum = {
            institution_id: institution_id,
            type: "6,9",
            code: `${value75000001.name75000001},${value75000001.value1}`
          };
          params = paramsTempNum;
        }else if (
          !IDNumber &&
          !hospitalNum &&
          !this.outerLinkParams &&
          !name && institution_id == "25500005"
        ) {
          let paramsTempNum = {
            institution_id: institution_id,
            type: "4,2,3",
            code: `${value25500005.value1},${value25500005.value1},${value25500005.value1}`,
            must: {key:"6",value: `${value25500005.name25500005}`}

          };
          params = paramsTempNum;
        }else if (
          !IDNumber &&
          !hospitalNum &&
          !this.outerLinkParams &&
          !name && institution_id == "73000005"
        ) {
          let paramsTempNum = {
            institution_id: institution_id,
            type: "1,2",
            code: `${value73000005.value1},${value73000005.value1}`,
            must: {key:"6",value: `${value73000005.name73000005}`}

          };
          params = paramsTempNum;
        }else if (
          !IDNumber &&
          !hospitalNum &&
          !this.outerLinkParams &&
          !name && institution_id == "06700001"
        ) {
          let paramsTempNum = {
            institution_id: institution_id,
            type: "4,1",
            code: `${value06700001.value1},${value06700001.value1}`,
            must: {key:"6",value: `${value06700001.name06700001}`}

          };
          params = paramsTempNum;
        }else if (
          !IDNumber &&
          !hospitalNum &&
          !this.outerLinkParams &&
          !name && institution_id == "012"
        ) {
          let paramsTempNum = {
            // institution_id: institution_id,
            type: "4",
            code: `${value012.value1}`,
            must: {key:"6",value: `${value012.name012}`}
          };
          console.log(paramsTempNum,'------')
          params = paramsTempNum;
        }else if (
          !IDNumber &&
          !hospitalNum &&
          !this.outerLinkParams &&
          !name && institution_id == "72700001"
        ) {
          let paramsTempNum = {
            institution_id: institution_id,
            type: "4,5",
            code: `${value72700001.value1},${value72700001.value1}`,
            must: {key:"6",value: `${value72700001.name72700001}`}

          };
          params = paramsTempNum;
        }else if (
          !IDNumber &&
          !hospitalNum &&
          !this.outerLinkParams &&
          !name && institution_id == "25500004"
        ) {
          let paramsTempNum = {
            institution_id: institution_id,
            type: "4",
            code: `${value25500004.value1}`,
            must: {key:"6",value: `${value25500004.name25500004}`}

          };
          params = paramsTempNum;
        }else if (
          !IDNumber &&
          !hospitalNum &&
          !this.outerLinkParams &&
          !name && institution_id == "30000004"
        ) {
          let paramsTempNum = {
            institution_id: institution_id,
            type: "5",
            code: `${value30000004.value1}`,
            must: {key:"6",value: `${value30000004.name30000004}`}

          };
          params = paramsTempNum;
        }else if (
          !IDNumber &&
          !hospitalNum &&
          !this.outerLinkParams &&
          !name && institution_id == "27100009"
        ) {
          let paramsTempNum = {
            institution_id: institution_id,
            type: "9",
            code: `${value27100009.value1}`,
            must: {key:"6",value: `${value27100009.name27100009}`}

          };
          params = paramsTempNum;
        }else if (
          !IDNumber &&
          !hospitalNum &&
          !this.outerLinkParams &&
          !name && institution_id == "74400013"
        ) {
          let paramsTempNum = {
            institution_id: institution_id,
            type: "4,1",
            code: `${value74400013.value1},${value74400013.value1}`,
            must: {key:"6",value: `${value74400013.name74400013}`}

          };
          params = paramsTempNum;
        }else if (
          !IDNumber &&
          !hospitalNum &&
          !this.outerLinkParams &&
          !name && institution_id == "71900001"
        ) {
          let paramsTempNum = {
            institution_id: institution_id,
            type: "4",
            code: `${value71900001.value1}`,
            must: {key:"6",value: `${value71900001.name71900001}`}

          };
          params = paramsTempNum;
        }else if (
          !IDNumber &&
          !hospitalNum &&
          !this.outerLinkParams &&
          !name && institution_id == "71900005"
        ) {
          let paramsTempNum
          if(value71900005.active == 2){//姓名与就诊时间
            paramsTempNum = {
              institution_id: institution_id,
              type: "9",
              code: `${value71900005.value1}`,
              must: {key:"6",value: `${value71900005.name71900005}`}
            };
          }else if(value71900005.active == 1){//姓名与身份证
            paramsTempNum = {
              institution_id: institution_id,
              type: "4",
              code: `${value71900005.value1}`,
              must: {key:"6",value: `${value71900005.name71900005}`}
            };
          }
          
          params = paramsTempNum;
        }else if (
          !IDNumber &&
          !hospitalNum &&
          !this.outerLinkParams &&
          !name && institution_id == "71900006"
        ) {
          let paramsTempNum
          if(value71900006.active == 2){//姓名与就诊时间
            paramsTempNum = {
              institution_id: institution_id,
              type: "9",
              code: `${value71900006.value1}`,
              must: {key:"6",value: `${value71900006.name71900006}`}
            };
          }else if(value71900006.active == 1){//姓名与身份证
            paramsTempNum = {
              institution_id: institution_id,
              type: "4",
              code: `${value71900006.value1}`,
              must: {key:"6",value: `${value71900006.name71900006}`}
            };
          }
          
          params = paramsTempNum;
        }else if (
          !IDNumber &&
          !hospitalNum &&
          !this.outerLinkParams &&
          !name && institution_id == "71900007"
        ) {
          let paramsTempNum
          if(value71900007.active == 2){//姓名与手机号
            paramsTempNum = {
              institution_id: institution_id,
              type: "5",
              code: `${value71900007.value1}`,
              must: {key:"6",value: `${value71900007.name71900007}`}
            };
          }else if(value71900007.active == 1){//姓名与身份证
            paramsTempNum = {
              institution_id: institution_id,
              type: "4",
              code: `${value71900007.value1}`,
              must: {key:"6",value: `${value71900007.name71900007}`}
            };
          }
          
          params = paramsTempNum;
        }else if (
          !IDNumber &&
          !hospitalNum &&
          !this.outerLinkParams &&
          !name &&  institution_id == "71900008"
        ) {
          let paramsTempNum
          if(value71900008.active == 2){//姓名与手机号
            paramsTempNum = {
              institution_id: institution_id,
              type: "5",
              code: `${value71900008.value1}`,
              must: {key:"6",value: `${value71900008.name71900008}`}
            };
          }else if(value71900008.active == 1){//姓名与身份证
            paramsTempNum = {
              institution_id: institution_id,
              type: "4",
              code: `${value71900008.value1}`,
              must: {key:"6",value: `${value71900008.name71900008}`}
            };
          }
          
          params = paramsTempNum;
        } else {
          params = JSON.parse(Storage.get("outerLinkParams"));
        }
      }
      this.getList(params);
    },
    async getList(val) {
      console.log(val, 'hdsdsidis')
      this.loading = true;
      this.isData = false;
      if (!val) {
        this.listData = [];
        this.total = 0;
        this.isData = true;
        this.loading = false;
        return;
      }
      let institution_id = window.localStorage.getItem("institution_id");
      const hasInstitution = Boolean(val.institution_id);
      const isSearchMode = institution_id == "012" &&
        !hasInstitution &&
        !this.isForwardedSearchLink;
      let params = {};
      if(isSearchMode){
        params = {
          ...val,
          check: this.check ? this.check : undefined,
          checkcode: this.checkcode ? this.checkcode : undefined
        };
      }else if (hasInstitution) {
        params = {
          ...val,
          institution_id: decodeURIComponent(val.institution_id),
          check: this.check ? this.check : undefined,
          checkcode: this.checkcode ? this.checkcode : undefined
        };
      } else {
        params = {
          ...val,
          check: this.check ? this.check : undefined,
          checkcode: this.checkcode ? this.checkcode : undefined
        };
      }
      const axiosApi = isSearchMode ? getAnotherAllReport : getAllReport
      let res = null;
      try {
        res = await axiosApi(params);
      } catch (error) {
        res = null;
      }
      this.listData = Array.isArray(res) ? res : [];
      this.total = this.listData.length;
      this.isCheck = false;
      this.isData = this.listData.length === 0;
      this.loading = false;
      // else {
      //   let outerLinkParams = JSON.parse(Storage.get("outerLinkParams"));
        // this.$router.go(-1);
        // this.isCheck = true;
      // }
    },
    async getPatientInfo(param, fromValue) {
      // { exam_id: item.exam_id ,insitution_id:item.institution_id}
      let params = { exam_id: param.exam_id };
      let res = await getPatientInfo(params);
      if (res.length) {
        this.listData = res
        Storage.set("reportInfo", res);
        Storage.set("studyId", res[0].study_id);
        Storage.set('fromValue', fromValue)
        // this.$router.push({ path: '/reportInfoOuter/report' })
        this.$router.push({
          path: "/reportInfoOuter",
          query: { institution_id: param.institution_id, reportBool: param.reportBool }
        });
      }
    },
    wechatPay(params) {
      let _this = this;
      axios
        .post("https://wechat.pacsonline.cn/wx_patient/api/getJsSdkConfig")
        .then(res => {
          wx.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["chooseWXPay"]
          });
          wx.chooseWXPay({
            timestamp: _this.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
            nonceStr: _this.nonceStr, // 支付签名随机串，不长于 32 位
            package: _this.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
            signType: _this.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
            paySign: _this.paySign, // 支付签名
            success: function(res) {
               _this.getAllReport();
              // 支付成功后的回调函数
             
            }
          });
        });
    },
    async getWechatPay(params) {
      let res = await ready2OutFilmPay(params);
      if (res) {
        this.nonceStr = res.nonceStr;
        this.package = res.package;
        this.paySign = res.paySign;
        this.signType = res.signType;
        this.timeStamp = res.timeStamp;
        this.wechatPay(params);
      }
    },
    async callReportPrint(item) {
      const exam_id = item.exam_id;
      const exam_status = item.exam_status;
      // 73000005 榆中县第一人民医院
      const institution_id = item.institution_id;
      // if (
      //   item.charge_mode == 1 &&
      //   item.pay_status == 0 &&
      //   item.film_price != 0
      // ) {
      //   alert('未支付数字影像服务费,无法查看报告原件')
      //   return
      // } else if (
      //   item.charge_mode == 3 &&
      //   item.pay_status == 0 &&
      //   item.film_price != 0
      // ) {
      //   alert('未支付数字影像服务费,请到医院缴费窗口缴费')
      //   return
      if (exam_status !== 9) {
        alert("报告未完成,无法查看报告原件");
        return;
      } else {
        if (institution_id === "73000005") {
          this.$router.push({
            path: "/printOuter1",
            query: { exam_id: exam_id, from: "reportList" }
          });
          return;
        }
        this.$router.push({
          path: "/printOuter",
          query: { exam_id: exam_id, from: "reportListOuter" }
        });
      }
      // let res = await getLocalReport()
    },
    onValidation() {
      if (this.checkcode.length == 4) {
        // this.isCheck = false;
        this.beforeLogic();
        this.$router.push({
          path: "reportListOuter",
          query: JSON.parse(Storage.get("outerLinkParams"))
        });
      } else {
        alert("验证码输入错误！");
      }
    },
    beforeLogic() {
      if (
        this.outerLinkParams &&
        this.outerLinkParams.institution_id == "83000004"
      ) {
        this.getDockList();
        this.isDropdown = true;
      } else {
        this.getAllReport();
        this.isDropdown = false;
      }
      // this.show = true
      var storage = window.localStorage;
      if (!storage.getItem("ismodal")) {
        this.show = true;
        storage.setItem("ismodal", true);
      }
    }
  },
  created() {
    const routeParams = this.$route && this.$route.query;
    this.isForwardedSearchLink = Boolean(
      !this.outerLinkParams &&
      routeParams &&
      !routeParams.institution_id &&
      routeParams.type &&
      routeParams.code
    );
    let url = window.location.href;
    if (url.indexOf("institution_id=") != -1&&url.indexOf("type=") != -1&&url.indexOf("code=") != -1 && getQueryString("institution_id") == '03060002') {
      if(url.indexOf("openid=") != -1){
        let openid = getQueryString("openid");
        Storage.set("openid",openid)
        this.beforeLogic();
        return
      }else{
        let institution_id = getQueryString("institution_id");
        let type = getQueryString("type");
        let code = getQueryString("code");
        if(url.indexOf("openid=") == -1){
          window.location.href="https://wechat.pacsonline.cn/wx_patient/web/reportExternalLink?institution_id="+institution_id+'&type='+type+'&codestr='+ code
        }
        return
      }
      
    }else{
      if (this.$route.query.check == 1) {
        this.checkTitle = "请输入身份证后四位";
        this.check = 1;
        this.isCheck = true;
        return;
      } else if (this.$route.query.check == 2) {
        this.checkTitle = "请输入手机号后四位";
        this.check = 2;
        this.isCheck = true;
        return;
      } else {
        this.check = "";
        this.checkcode = "";
        this.beforeLogic();
      }
    }
    
  }
};
</script>
<style lang="scss" scoped>
.reportList {
  height: 100%;
  width: 100%;
  background: #eeeeee;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  color: #000;
  .listLoading {
    flex: 1;
    min-height: 220px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #666;
  }
  .noData {
    height: 24px;
    font-size: 14px;
    color: #999999;
    line-height: 24px;
    margin-top: 60px;
  }
  .dropdown {
    height: 44px;
    background: gray;
    position: relative;
    margin-bottom: 10px;
    .label {
      height: 100%;
      line-height: 44px;
      position: absolute;
      left: 10px;
      z-index: 99;
      margin: 0;
    }
  }
  .back {
    width: 2rem;
    height: 0.72rem;
    background: #26b3c6;
    font-size: 0.37333rem;
    color: #fff;
    line-height: 0.72rem;
    border-top-right-radius: 0.4rem;
    border-bottom-right-radius: 0.4rem;
    text-align: center;
    position: fixed;
    bottom: 3rem;
    left: -0.26667rem;
    z-index: 10;
  }
  .backSearch {
    width: 2.5rem;
    height: 1rem;
    line-height: 1rem;
    font-size: 0.44rem;
    border-top-right-radius: 0.44rem;
    border-bottom-right-radius: 0.44rem;
  }
  .total {
    width: 100%;
    height: 30px;
    line-height: 30px;
    font-size: 10px;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    color: #000;
    .return {
      width: 30px;
      font-size: 15px;
      color: #51cde4;
    }
  }
}
.scrollBox {
  width: 80%;
  height: 80%;
  margin: 0 auto;
  padding: 20px;
  background: #ffffff;
}
.blocks::-webkit-scrollbar {
  display: none;
}
.blocks {
  // width: 80%;
  height: 100%;
  border-radius: 10px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
.blocks div {
  font-size: 14px;
  text-align: center;
  font-weight: bold;
}
.blocks p {
  text-align: left;
  text-indent: 2em;
}
.blocks .subTitle {
  font-weight: bold;
}

// ceshi
/* 弹窗 */
#mask {
  // display: block;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}
.scrollBoxModel {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 50%;
  top: 50%;
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  z-index: 101;
  display: flex;
  align-items: center;
}
.checkButton {
  width: 80px;
  padding: 5px 0;
  margin-top: 20px;
  background-color: #409eff;
  border: 1px solid #409eff;
  border-radius: 3px;
  color: #ffffff;
}
.email-input{
  width: 70%;
  margin: 30px 0 15px;
  border-radius: 10px;
  padding: 10px;
  border: none;
  border-bottom: 1px solid rgb(184, 183, 183);
}
</style>
